export default __webpack_public_path__ + "static/media/sh_1.51741d4b.png";